import {
    type GetInitialConfigsResponseType,
    type GetInitialConfigsRequestType
} from "./type";
import {
    request
} from "../request";

const getInitialConfigs = async (params: GetInitialConfigsRequestType = {}): Promise<GetInitialConfigsResponseType> => {
    const query = params.language ? `?language=${encodeURIComponent(params.language)}` : "";

    return await request<GetInitialConfigsResponseType>(`/staticData/getInitialConfigs${query}`, {
        method: "GET"
    });
};
export default getInitialConfigs;
